import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { getMedicationDosageText, getMedicationEmptyMessage } from '@/modules/app/utils/medication.utils'
import { StObservationItem } from '@/modules/shared/components/observation-item/ObservationItem'

import type { MedicationSchemeStatus, MedicationStatement } from '@/modules/app/types/HealthParameter.types'

type MedicationListProps = {
  medications: MedicationStatement[]
  schemeStatus?: MedicationSchemeStatus
}

export const MedicationList = ({ medications, schemeStatus }: MedicationListProps) => {
  const theme = useTheme()

  if (medications.length === 0) {
    return <StObservationItem type='BodyMediumRegular'>{getMedicationEmptyMessage(schemeStatus)}</StObservationItem>
  }

  return (
    <FlexColumn gap={theme.UI.Spacing.Space1}>
      {medications.map((medication, index) => {
        const dosageText = getMedicationDosageText(medication)
        return (
          <StObservationItem key={`${medication.name}-${index}`} type='BodyMediumRegular'>
            <FlexColumn gap={theme.UI.Spacing.Space1}>
              <Span type='BodyMediumRegular' style={{ fontWeight: '500' }} color={theme.Colors.Neutrals.Darker}>
                {medication.name}
              </Span>
              {dosageText && (
                <Span type='BodyMediumRegular' color={theme.Colors.Neutrals.Darker}>
                  {dosageText}
                </Span>
              )}
            </FlexColumn>
          </StObservationItem>
        )
      })}
    </FlexColumn>
  )
}
